import React from "react";
import { useLoaderData } from "react-router-dom";
import ReviewTable from "./ReviewTable";

const Myreviews = () => {
  const myReview = useLoaderData();
  console.log(myReview);
  return (
    <div className=" container mx-auto">
      <h1 className="text-5xl text-center my-12 ">My All Reviews</h1>
      {myReview.length === 0 ? (
        <h1 className="text-center m-32 h-full">No reviews were added!!!</h1>
      ) : (
        <table className="mx-auto table-fixed my-12">
          <thead className="border border-2 bg-blue-200">
            <tr>
              <th>Delete</th>
              <th>Service</th>
              <th>Review</th>

              <th>Update Review</th>
            </tr>
          </thead>
          <tbody>
            {myReview.map((review) => (
              <ReviewTable key={review._id} myallreview={review}></ReviewTable>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default Myreviews;
